import { Card } from "@/components/ui/card";
import { Thermometer, Drop, BatteryFull, Warning, Lightbulb } from "@phosphor-icons/react";

export default function KPICards({ summary }) {
  if (!summary) return null;

  const lightData = summary.light || {};
  const isSealed = lightData.is_sealed !== false;

  const cards = [
    {
      label: "Temperature",
      value: `${summary.temperature.current}\u00b0F`,
      detail: `Avg ${summary.temperature.avg}\u00b0F \u2022 ${summary.temperature.min}\u2013${summary.temperature.max}\u00b0F`,
      icon: Thermometer,
      color: "text-teal-400",
      bgColor: "bg-teal-400/10",
    },
    {
      label: "Humidity",
      value: `${summary.humidity.current}%`,
      detail: `Avg ${summary.humidity.avg}% \u2022 ${summary.humidity.min}\u2013${summary.humidity.max}%`,
      icon: Drop,
      color: "text-emerald-400",
      bgColor: "bg-emerald-400/10",
    },
    {
      label: "Light",
      value: lightData.current || "N/A",
      detail: isSealed
        ? `Sealed \u2022 ${lightData.dark_count || 0} dark readings`
        : `${lightData.light_detected_count || 0} exposure events \u2022 ${lightData.exposure_percentage || 0}%`,
      icon: Lightbulb,
      color: isSealed ? "text-emerald-400" : "text-amber-400",
      bgColor: isSealed ? "bg-emerald-400/10" : "bg-amber-400/10",
    },
    {
      label: "Battery",
      value: `${summary.battery.current}%`,
      detail: `Avg ${summary.battery.avg}% \u2022 Min ${summary.battery.min}%`,
      icon: BatteryFull,
      color:
        summary.battery.current > 50 ? "text-emerald-400" : "text-amber-400",
      bgColor:
        summary.battery.current > 50 ? "bg-emerald-400/10" : "bg-amber-400/10",
    },
    {
      label: "Alerts",
      value: summary.alerts.total,
      detail: `${summary.event_count} events analyzed`,
      icon: Warning,
      color:
        summary.alerts.total > 0 ? "text-red-400" : "text-emerald-400",
      bgColor:
        summary.alerts.total > 0
          ? "bg-red-400/10"
          : "bg-emerald-400/10",
    },
  ];

  return (
    <div
      data-testid="kpi-cards"
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4"
    >
      {cards.map((card) => (
        <Card
          key={card.label}
          className="bg-zinc-900 border-zinc-800 rounded-sm p-4 hover:bg-zinc-800/50 transition-colors duration-200"
          data-testid={`kpi-${card.label.toLowerCase()}`}
        >
          <div className="flex items-start justify-between">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-2">
                {card.label}
              </p>
              <p className="text-3xl font-mono tracking-tighter font-semibold text-zinc-50">
                {card.value}
              </p>
              <p className="text-xs text-zinc-500 mt-1.5 font-mono">
                {card.detail}
              </p>
            </div>
            <div className={`p-2 rounded-sm ${card.bgColor}`}>
              <card.icon size={24} weight="duotone" className={card.color} />
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
